import React from 'react';
import PropTypes from 'prop-types';

import { useSearchType } from '@context/searchTypeContext';
import CloseIcon from '@icons/CloseIcon';
import CompanyFilters from '../CompanyFilters';
import MemberFilters from '../MemberFilters';
import { CurrentFilters } from '@search';
import ArticleFilters from '../ArticleFilters';
import EventFilters from '../EventFilters';
import EverythingFilters from '../EverythingFilters';
import { formatFilterLabel } from '../../../helpers/formatContentTypeLabel';

const FiltersOverlay = ({ open, onClose }) => {
    const [searchType] = useSearchType();
    const containerStyles = {
        ...styles.container,
        visibility: open ? 'visible' : 'hidden',
    };

    return (
        <div style={containerStyles}>
            <div style={styles.header}>
                <h1 className="mb-0">Filter Results</h1>
                <h2 className="mb-0">
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ WebkitAppearance: 'none', border: 'none', background: 'transparent' }}
                    >
                        <CloseIcon />
                    </button>
                </h2>
            </div>

            <div style={styles.body}>
                <div className="pb-4" style={styles.currentFiltersContainer}>
                    <CurrentFilters
                        buttonClasses="display8"
                        clearAllClasses="display9"
                        useButtons
                        onClose={onClose}
                        formatLabel={formatFilterLabel}
                    />
                </div>

                {searchType.index === 'members' && <MemberFilters />}
                {searchType.index === 'member_events' && <MemberFilters />}
                {searchType.index === 'companies' && <CompanyFilters />}
                {searchType.index === 'articles' && <ArticleFilters />}
                {searchType.index === 'events' && <EventFilters />}
                {searchType.index === 'everything' && <EverythingFilters />}
            </div>
        </div>
    );
};

FiltersOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

const styles = {
    container: {
        background: '#fff',
        bottom: 0,
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: 99999,
    },
    header: {
        backgroundColor: '#323333',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '58px',
        left: 0,
        padding: '10px 20px',
        position: 'fixed',
        right: 0,
    },
    body: {
        bottom: 0,
        left: 0,
        overflow: 'scroll',
        padding: '20px',
        position: 'fixed',
        right: 0,
        top: '58px',
    },
    currentFiltersContainer: {
        borderBottom: '1px solid #000',
    },
};

export default FiltersOverlay;
